import React from "react";
import { View, StyleSheet } from "react-native";
import NtMarketingSectionContainer from "../general/NtMarketingSectionContainer";
import NtGovermentText from "./NtGovermentText";
import NtGovermentTextBullet from "./NtGovermentTextBullet";
import NtSectionTitle from "../general/NtSectionTitle";
import NtGovermentTitle from "./NtGovermentTitle";
import NtGovermentTextBold from "./NtGovermentTextBold";
import NtText from "../../../components/NtText";
import NtDevider from "../../../components/NtDevider";
import { useMobile } from "../../../hooks/useMobile";
import NtTouchableEffect from "../../../components/NtTouchableEffect";
import colors from "../../../config/colors";

function NtGovermentInfoSection(props) {
  const isMobile = useMobile();
  const renderTable = (containerStyle) => {
    return (
      <View
        style={[
          { borderColor: "#3c3c3c", borderWidth: 1, borderRadius: 10 },
          containerStyle,
        ]}
      >
        {/* line 1 */}
        <View style={{}}>
          <View style={{ flexDirection: "row", alignItems: "center" }}>
            <NtGovermentText style={{ flex: 1, padding: 10 }}>
              Interconnected VoIP
            </NtGovermentText>
            <View
              style={{ backgroundColor: "#3c3c3c", height: "100%", width: 1 }}
            />
            <NtGovermentText style={{ flex: 1, padding: 10 }}>
              POTS to SIP Modernization
            </NtGovermentText>
          </View>
          <View
            style={{ backgroundColor: "#3c3c3c", width: "100%", height: 1 }}
          />
        </View>

        {/* line 2 */}
        <View style={{}}>
          <View style={{ flexDirection: "row", alignItems: "center" }}>
            <NtGovermentText style={{ flex: 1, padding: 10 }}>
              Enterprise Grade Deployments
            </NtGovermentText>
            <View
              style={{ backgroundColor: "#3c3c3c", height: "100%", width: 1 }}
            />
            <NtGovermentText style={{ flex: 1, padding: 10 }}>
              Unified Communications (UCaaS)
            </NtGovermentText>
          </View>
          <View
            style={{ backgroundColor: "#3c3c3c", width: "100%", height: 1 }}
          />
        </View>

        {/* line 3 */}
        <View style={{}}>
          <View style={{ flexDirection: "row", alignItems: "center" }}>
            <NtGovermentText style={{ flex: 1, padding: 10 }}>
              TDM to IP HW Deployments
            </NtGovermentText>
            <View
              style={{ backgroundColor: "#3c3c3c", height: "100%", width: 1 }}
            />
            <NtGovermentText style={{ flex: 1, padding: 10 }}>
              On-Premises and Cloud PBX
            </NtGovermentText>
          </View>
          <View
            style={{ backgroundColor: "#3c3c3c", width: "100%", height: 1 }}
          />
        </View>

        {/* line 4 */}
        <View style={{}}>
          <View style={{ flexDirection: "row", alignItems: "center" }}>
            <NtGovermentText style={{ flex: 1, padding: 10 }}>
              API & Middleware Development
            </NtGovermentText>
            <View
              style={{ backgroundColor: "#3c3c3c", height: "100%", width: 1 }}
            />
            <NtGovermentText style={{ flex: 1, padding: 10 }}>
              Enterprise Grade DevOps & DEVSecOps: CI/CD/laC
            </NtGovermentText>
          </View>
          <View
            style={{ backgroundColor: "#3c3c3c", width: "100%", height: 1 }}
          />
        </View>

        {/* line 5 */}
        <View style={{}}>
          <View style={{ flexDirection: "row", alignItems: "center" }}>
            <NtGovermentText style={{ flex: 1, padding: 10 }}>
              Mobile Application Development
            </NtGovermentText>
            <View
              style={{ backgroundColor: "#3c3c3c", height: "100%", width: 1 }}
            />
            <NtGovermentText style={{ flex: 1, padding: 10 }}>
              Cloud-Native & Hybrid Cloud Support
            </NtGovermentText>
          </View>
          <View
            style={{ backgroundColor: "#3c3c3c", width: "100%", height: 1 }}
          />
        </View>

        {/* line 6 */}
        <View style={{}}>
          <View style={{ flexDirection: "row", alignItems: "center" }}>
            <NtGovermentText style={{ flex: 1, padding: 10 }}>
              SMS over IP, RCS, XMPP, AMQP, MQTT, WebRTC
            </NtGovermentText>
            <View
              style={{ backgroundColor: "#3c3c3c", height: "100%", width: 1 }}
            />
            <NtGovermentText style={{ flex: 1, padding: 10 }}>
              Apple Push Notifications, Google Firebase Cloud Messaging
            </NtGovermentText>
          </View>
        </View>
      </View>
    );
  };

  return (
    <NtMarketingSectionContainer style={styles.container}>
      <View style={{ flex: 1, flexDirection: isMobile ? "column" : "row" }}>
        {/* let */}
        <View
          style={{
            flex: 1,
            marginRight: isMobile ? 0 : 15,
            marginBottom: isMobile ? 15 : 0,
          }}
        >
          {/* company */}
          <View style={[styles.boxBackground]}>
            <NtGovermentTitle>COMPANY OVERVIEW</NtGovermentTitle>
            <NtGovermentText style={{ marginTop: 15 }}>
              <NtGovermentTextBold>
                NT Connect Holdings, Inc.
              </NtGovermentTextBold>{" "}
              (NT Connect) established in 2018, is a leading provider of
              communication intelligence and IT solutions, specializing in
              building and managing mission-critical communication networks. We
              offer advanced services including LEO satellite connectivity,
              location-based services, contact tracing, access control systems,
              and cutting-edge telehealth technologies. Our clients include the
              U.S. Navy, Canadian Coast Guard, Cunard Line, Disney Cruise Line,
              Holland America, Norwegian Cruise Line, and P&O Cruises.
            </NtGovermentText>
          </View>

          {/* core competencies */}
          <View style={[{ marginTop: 15 }, styles.boxBackground]}>
            <NtGovermentTitle>CORE COMPETENCIES</NtGovermentTitle>

            {renderTable({ marginTop: 20 })}
          </View>

          {/* differenciators */}
          <View style={[{ marginTop: 15 }, styles.boxBackground]}>
            <NtGovermentTitle>DIFFERENTIATORS</NtGovermentTitle>
            <NtGovermentText style={{ marginTop: 15 }}>
              <NtGovermentTextBold>NT Connect</NtGovermentTextBold> delivers
              secure communication systems for government, enterprise, and
              maritime sectors. Our proven expertise in air-gapped maritime
              environments seamlessly extends to land-based projects, providing
              tailored, user-friendly solutions in even the most challenging
              settings.{"\n\n"}
              <NtGovermentTextBold>
                Why Do Customers Choose Us?
              </NtGovermentTextBold>
              {"\n"}NT Connect maximizes ROI by leveraging existing equipment,
              ensuring the initial investment is retained, while seamlessly
              modernizing the backend for enhanced performance and scalability.
              NT Connect’s proven Methodology Framework—from discovery to
              support—ensures quality control, clear expectations, and on-time
              delivery. Our secure, customizable solutions serve both maritime
              and land-based environments, consistently delivering high-quality
              results in complex, remote settings. With deep expertise and a
              strong track record, we are a reliable partner for
              mission-critical communication systems.
            </NtGovermentText>
          </View>

          {/* maritime */}
          <View style={[{ marginTop: 15 }, styles.boxBackground]}>
            <NtGovermentTitle>MARITIME</NtGovermentTitle>
            <NtGovermentText style={{ marginTop: 15 }}>
              <NtGovermentTextBold>Commercial Maritime</NtGovermentTextBold>
              {"\n"}
              NT Maritime, the maritime division of NT Connect Holdings, Inc.,
              is dedicated to delivering secure, mission-critical communication
              and IT solutions across all oceans - focused on cruise lines,
              private ports, and hospitality. Our team blends deep industry
              expertise with cutting-edge technology to ensure cruise vessels
              stay connected, safe, and efficient—no matter how far offshore.
              {"\n\n"}
              Built on a legacy of excellence from NT Connect, which has served
              government, enterprise, and maritime clients since 2018, NT
              Maritime focuses exclusively on the unique challenges of vessel
              communications in the commercial sector. From cruise ships to
              offshore platforms, we've built systems that work in the toughest
              and most remote marine environments. For more information:
              <NtTouchableEffect
                onPress={() => {
                  window.open("https://ntmaritime.com");
                }}
              >
                <NtText style={{ color: "#00a5ff" }}>
                  https://ntmaritime.com
                </NtText>
              </NtTouchableEffect>
              {"\n\n"}
              <NtGovermentTextBold>Goverment Maritime</NtGovermentTextBold>
              {"\n"}Mission-Critical Maritime Communications for Federal and
              Military Operations, NT Connect provides secure, resilient, and
              scalable communications solutions to the United States Navy and
              Coast Guard's.{"\n\n"}With active contracts supporting U.S. Navy
              vessel transitions, Carrier Strike Group support, and lighthouse
              communications modernization for the Canadian Coast Guard, NT
              Connect delivers real-world expertise in:
            </NtGovermentText>
            <NtGovermentTextBullet containerStyle={{ marginTop: 10 }}>
              Secure Shipboard VoIP and Unified Communications
            </NtGovermentTextBullet>

            <NtGovermentTextBullet containerStyle={{ marginTop: 10 }}>
              Fleet Maintenance Data Systems and Preventive Maintenance
              Integration
            </NtGovermentTextBullet>

            <NtGovermentTextBullet containerStyle={{ marginTop: 10 }}>
              Port Infrastructure Cybersecurity Support
            </NtGovermentTextBullet>

            <NtGovermentTextBullet containerStyle={{ marginTop: 10 }}>
              Expeditionary and Remote Maritime Comms
            </NtGovermentTextBullet>

            <NtGovermentTextBullet containerStyle={{ marginTop: 10 }}>
              24/7 Help Desk and Remote Technical Assistance for Port and Fleet
              Operations
            </NtGovermentTextBullet>

            <NtGovermentText style={{ marginTop: 10 }}>
              NT Connect operates as a trusted partner to both military and
              commercial maritime entities, with direct award wins and active
              participation in U.S. Navy and DHS programs. Solutions available
              via DISA DITCO, 8(a), GSA MAS, and Indian-Owned Contract Vehicles
              through our strategic partnerships.{"\n\n"}Ready to modernize your
              fleet’s communications and IT infrastructure? Contact us today.
            </NtGovermentText>
          </View>

          {/* past performance */}
          <View style={[{ marginTop: 15 }, styles.boxBackground]}>
            <NtGovermentTitle>PAST PERFORMANCE</NtGovermentTitle>

            <NtGovermentText style={{ marginTop: 15 }}>
              <NtGovermentTextBold>
                U.S. Air Force - Ohio Air National Guard Base - 179th Cyberspace
                Wing:
              </NtGovermentTextBold>{" "}
              Aug 2025 - SIP Telephony Services - Mansfield, OH
            </NtGovermentText>
            <NtGovermentText style={{ marginTop: 15 }}>
              <NtGovermentTextBold>
                U.S. Air Force - Will Rogers Air National Guard Base - 137th
                Special Operations Wing:
              </NtGovermentTextBold>{" "}
              July 2025 - SIP Voice Services - Oklahoma City, OK
            </NtGovermentText>
            <NtGovermentText style={{ marginTop: 15 }}>
              <NtGovermentTextBold>
                Department of Defense - Defense Information Systems Agency
                (DISA):
              </NtGovermentTextBold>{" "}
              July 2025 - Information Technology, Telecommunications, Satellite
              Bandwidth, Combat Support Computing & Enterprise Services - Scott
              AFB, IL
            </NtGovermentText>
            <NtGovermentText style={{ marginTop: 15 }}>
              <NtGovermentTextBold>
                U.S. Air Force - Mountain Home Air Force Base:
              </NtGovermentTextBold>{" "}
              June 2025 - SIP Telecommunication Services - Mtn. Home AFB, ID
            </NtGovermentText>
            <NtGovermentText style={{ marginTop: 15 }}>
              <NtGovermentTextBold>
                U.S. Dept of Commerce - National Oceanic and Atmospheric
                Administration (NOAA):
              </NtGovermentTextBold>{" "}
              May 2025 - PA / PBX modernization - Ship Bell M. Shimada
            </NtGovermentText>
            <NtGovermentText style={{ marginTop: 15 }}>
              <NtGovermentTextBold>
                Department of the Army - Air National Guard (153rd Airlift
                Wing):
              </NtGovermentTextBold>{" "}
              March 2025 - LSTDM to SIP Trunking modernization - Wyoming Air
              National Guard Base
            </NtGovermentText>
            <NtGovermentText style={{ marginTop: 15 }}>
              <NtGovermentTextBold>
                U.S. Navy NAVSUP - Fleet Logistics Center:
              </NtGovermentTextBold>{" "}
              March 2025 - VoIP Communications - Carrier Strike Group 4
            </NtGovermentText>
            <NtGovermentText style={{ marginTop: 15 }}>
              <NtGovermentTextBold>
                U.S. Navy / NAVSUP - Naval Supply Systems Command:
              </NtGovermentTextBold>{" "}
              September 2024 - VoIP Transition Naval Air Station Key West
            </NtGovermentText>
            <NtGovermentText style={{ marginTop: 15 }}>
              <NtGovermentTextBold>
                Canadian Coast Guard / Inmarsat:
              </NtGovermentTextBold>{" "}
              2021-present - Aids to Navigation – Lighthouse Communications
              along Canadian Coast
            </NtGovermentText>
          </View>
        </View>
        {/* right */}
        <View style={[{}, styles.boxBackground]}>
          <NtGovermentTitle style={{}}>COMPANY DATA</NtGovermentTitle>

          <NtGovermentTextBullet containerStyle={{ marginTop: 15 }}>
            <NtGovermentTextBold>UEI:</NtGovermentTextBold> VXB5ZNM6U189
          </NtGovermentTextBullet>

          <NtGovermentTextBullet containerStyle={{ marginTop: 15 }}>
            <NtGovermentTextBold>DUNS:</NtGovermentTextBold> 111241976
          </NtGovermentTextBullet>

          <NtGovermentTextBullet containerStyle={{ marginTop: 15 }}>
            <NtGovermentTextBold>CAGE Code:</NtGovermentTextBold> 9TQL0
          </NtGovermentTextBullet>

          <NtGovermentTextBullet containerStyle={{ marginTop: 15 }}>
            <NtGovermentTextBold>SBA:</NtGovermentTextBold> Self Certified Small
            Business
          </NtGovermentTextBullet>

          <NtGovermentTextBullet containerStyle={{ marginTop: 35 }}>
            <NtGovermentTextBold>Primary NAICS:</NtGovermentTextBold> 517111
            Business
          </NtGovermentTextBullet>

          <NtGovermentTextBullet
            containerStyle={{ marginLeft: 15, marginTop: 5 }}
          >
            238210
          </NtGovermentTextBullet>

          <NtGovermentTextBullet
            containerStyle={{ marginLeft: 15, marginTop: 5 }}
          >
            334210
          </NtGovermentTextBullet>

          <NtGovermentTextBullet
            containerStyle={{ marginLeft: 15, marginTop: 5 }}
          >
            517810
          </NtGovermentTextBullet>

          <NtGovermentTextBullet
            containerStyle={{ marginLeft: 15, marginTop: 5 }}
          >
            541511
          </NtGovermentTextBullet>

          <NtGovermentTextBullet
            containerStyle={{ marginLeft: 15, marginTop: 5 }}
          >
            541519
          </NtGovermentTextBullet>

          <NtGovermentTextBullet
            containerStyle={{ marginLeft: 15, marginTop: 5 }}
          >
            541512
          </NtGovermentTextBullet>

          <NtGovermentTextBullet
            containerStyle={{ marginLeft: 15, marginTop: 5 }}
          >
            518210
          </NtGovermentTextBullet>

          <NtGovermentTextBullet
            containerStyle={{ marginLeft: 15, marginTop: 5 }}
          >
            334290
          </NtGovermentTextBullet>

          <NtGovermentTextBullet containerStyle={{ marginTop: 35 }}>
            <NtGovermentTextBold>Certifications:</NtGovermentTextBold> ISO 27001
          </NtGovermentTextBullet>

          <NtGovermentTextBullet containerStyle={{ marginTop: 35 }}>
            <NtGovermentTextBold>Goverment Contact:</NtGovermentTextBold>
            {"\n"}Nick Kyriakides, COO{"\n"}Email: nick@ntconnect.com
          </NtGovermentTextBullet>

          <NtGovermentTextBullet containerStyle={{ marginTop: 35 }}>
            <NtGovermentTextBold>DSBS:</NtGovermentTextBold>{" "}
            <NtTouchableEffect
              onPress={() => {
                window.open(
                  "https://search.certifications.sba.gov/profile/VXB5ZNM6U189/9TQL0?page=1"
                );
              }}
            >
              <NtText style={{ color: "#00a5ff" }}>Porfolio Link</NtText>
            </NtTouchableEffect>
          </NtGovermentTextBullet>
        </View>
      </View>
    </NtMarketingSectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingTop: 60,
    paddingBottom: 60,
  },
  boxBackground: {
    borderRadius: 10,
    paddingLeft: 10,
    paddingRight: 10,
    paddingTop: 15,
    paddingBottom: 15,
    backgroundColor: "#181818",
  },
});

export default NtGovermentInfoSection;
